import React, { Component } from 'react';
import logo from '../assets/img/logoOxford2.png';
import { Link } from 'gatsby';

class Nav extends Component {
  render() {
    return (
      <>
        <nav className="nav">
          <div className="container">
            <a className="logo" href="/">
              <img src={logo} height="50px" />
            </a>
            <div className="opciones">
              <Link to="/">
                <span>inicio</span>
              </Link>
              <Link to="/Nosotros">
                <span>sobre nosotros</span>
              </Link>
              <Link to="/Cursos">
                <span>Cursos</span>
              </Link>
              <Link to="/Examenes">
                <span>Exámenes</span>
              </Link>
              <Link to="/Viajes">
                <span>Viajes</span>
              </Link>
              <Link to="/Inscripcion">
                <button className="button ">Inscribite ahora</button>
              </Link>
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default Nav;
